import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import withStyles from 'isomorphic-style-loader/withStyles';

import { ProgressBar, Button, Tab, Tabs } from 'react-bootstrap';

import MultiNetworkEdge from '../MultiNetworkEdge';
import Evidence from '../Evidence';
import Tooltip from '../Tooltip';

import s from './EdgeDetail.css';

/*
 * State-less component to display evidence and additional detail for
 * a network edge
 */

const EdgeDetail = ({
  edge,
  evidence,
  edgeNetworks,
  termDatabases,
  networkTitle,
  onGeneSelect,
  containerWidth,
}) => {
  let multinetwork = null;

  // Load evidence view of selected edge. Show a progress bar if
  // edge is selected but evidence is not available.
  if (evidence) {
    evidence = (
      <Evidence
        datasets={evidence.datasets}
        datatypes={evidence.datatypes}
        posterior={edge.weight}
        networkTitle={networkTitle}
        containerWidth={containerWidth}
        title={
          <h3 style={{ textAlign: 'center' }}>
            {edge.source.standard_name} and {edge.target.standard_name}
            <br />
            <small>
              Evidence in <em>{networkTitle}</em>
              <Tooltip
                text="Help with evidence"
                url="http://humanbase.readthedocs.io/en/latest/functional-networks.html#evidence"
              />
            </small>
          </h3>
        }
      />
    );
  } else if (edge)
    evidence = (
      <ProgressBar active striped label="Retrieving evidence" now={100} />
    );
  else
    evidence = (
      <div className="alert alert-info">
        Click on an edge in the network to view additional detail.
      </div>
    );

  // Load multi-network view of selected edge. Show a progress bar if
  // edge is selected but networks are not available.
  if (edgeNetworks) {
    multinetwork = (
      <MultiNetworkEdge
        networkTitle={networkTitle}
        edgeNetworks={edgeNetworks}
        edge={edge}
        containerWidth={containerWidth}
        title={
          <h3 style={{ textAlign: 'center' }}>
            {edge.source.standard_name} and {edge.target.standard_name}
            <br />
            <small>
              Interaction confidence in <em>all networks</em>
            </small>
          </h3>
        }
      />
    );
  } else if (edge)
    multinetwork = (
      <ProgressBar active striped label="Retrieving all networks" now={100} />
    );

  return (
    <div className={s.root}>
      <Tabs
        className="tab-under"
        id="edge-detail"
        defaultActiveKey={1}
        bsStyle="pills"
      >
        <Tab eventKey={1} title={networkTitle || 'This network'}>
          {evidence}
        </Tab>
        <Tab eventKey={2} title="All networks">
          {multinetwork}
        </Tab>
      </Tabs>
    </div>
  );
};

EdgeDetail.propTypes = {
  // Edge object containing source and target genes
  edge: PropTypes.object.isRequired,

  // Evidence corresponding to edge
  evidence: PropTypes.object,

  // Array of corresponding edge in multiple networks
  edgeNetworks: PropTypes.array,

  // Array of term databases for gene/term predictions
  termDatabases: PropTypes.array,

  // Title of the corresponding network
  networkTitle: PropTypes.string,

  // Callback for gene selection by user
  onGeneSelect: PropTypes.func,
};

export default withStyles(s)(EdgeDetail);
